import data from "../../.sourceflow/branded_job_ads.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const branded_job_ads= new CollectionHelper(data);
